/**
 * String helpers
 * @module lib/string
 */

/**
 * Escape HTML characters within given text
 * // https://stackoverflow.com/a/4835406
 * @param {string} text
 */
export function escapeHtml(text) {
  var map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };

  return text.replace(/[&<>"']/g, m => map[m]);
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/lib/string.js